<div class="px-4 py-8 md:px-6 lg:px-8">
	<div class="text-center">
		<span class="font-bold text-1xl inline-block px-3">404</span>
	</div>
	<div class="mt-6 mb-5 font-bold text-5xl text-900 text-center">
		Page Not Found
	</div>
	<p class="text-700 text-2xl mt-0 mb-6 text-center">
		Sorry, we couldn't find the page.
	</p>
	<div class="text-center">
		<p-button [text]="true" (onClick)="back()" class="mr-2">
			<fa-icon [icon]="['fas', 'arrow-left']"></fa-icon>
			<span>Go Back</span>
		</p-button>
		<a pButton routerLink="../dashboard">Go to Dashboard</a>
	</div>
</div>
